import { render } from "./BaseDialogPrompt.vue?vue&type=template&id=f9fcee9c&scoped=true"
import script from "./BaseDialogPrompt.vue?vue&type=script&lang=js"
export * from "./BaseDialogPrompt.vue?vue&type=script&lang=js"

import "./BaseDialogPrompt.vue?vue&type=style&index=0&id=f9fcee9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fcee9c"]])

export default __exports__